// Títulos fijos para todos los listados, sin que la tabla scrollee por dentro.
//
// La página baja completa y sólo se quedan arriba los títulos de la tabla. No se
// puede con `position: sticky`: las tablas anchas scrollean de lado, y un contenedor
// con scroll horizontal hace que sticky se pegue a él y no a la página. Por eso,
// cuando los títulos salen de la pantalla se muestra una copia fija que sigue a la
// tabla al moverse de lado; el clic en un título se pasa al original para ordenar.
//
// Por lo mismo se agrega una barra horizontal abajo: la de la tabla queda después de
// todos los renglones y sin ella no se podría mover de lado sin ir hasta el final.

const ESTILOS_COPIADOS = [
  "color", "font-size", "font-weight", "font-family", "letter-spacing", "text-transform",
  "text-align", "vertical-align", "white-space", "padding-top", "padding-right",
  "padding-bottom", "padding-left", "border-bottom-width", "border-bottom-style", "border-bottom-color",
];
const CELDAS = "th, td";
const FECHA = /^\d{4}-\d{2}-\d{2}$/;

const tiras = new Map();
let barra = null;
let contenidoBarra = null;
let tablaDeBarra = null;

function contenedorDe(tabla) {
  for (let n = tabla; n && n !== document.body; n = n.parentElement) {
    const { overflowX } = getComputedStyle(n);
    if (overflowX === "auto" || overflowX === "scroll") return n;
  }
  return tabla;
}

function crearTira() {
  const tira = document.createElement("div");
  tira.className = "titulos-fijos";
  const copia = document.createElement("table");
  copia.className = "table titulos-fijos-tabla";
  tira.appendChild(copia);
  document.body.appendChild(tira);
  return { tira, copia, html: null, medidas: "" };
}

function copiarTitulos(tabla, estado) {
  const { tHead } = tabla;
  const nuevo = tHead.cloneNode(true);
  nuevo.querySelectorAll("[id]").forEach((n) => n.removeAttribute("id"));
  estado.copia.replaceChildren(nuevo);

  const copias = nuevo.querySelectorAll(CELDAS);
  tHead.querySelectorAll(CELDAS).forEach((celda, i) => {
    const css = getComputedStyle(celda);
    ESTILOS_COPIADOS.forEach((p) => copias[i].style.setProperty(p, css.getPropertyValue(p), "important"));
    copias[i].addEventListener("click", () => celda.click());
  });

  estado.html = tHead.innerHTML;
  estado.medidas = "";
}

function ajustarMedidas(tabla, estado) {
  const anchos = Array.from(tabla.tHead.querySelectorAll(CELDAS), (c) => c.getBoundingClientRect().width);
  const medidas = anchos.join();
  if (medidas === estado.medidas) return;
  estado.medidas = medidas;
  estado.copia.querySelectorAll(CELDAS).forEach((c, i) => {
    c.style.width = `${anchos[i]}px`;
    c.style.minWidth = `${anchos[i]}px`;
    c.style.maxWidth = `${anchos[i]}px`;
  });
  estado.copia.style.width = `${tabla.tHead.getBoundingClientRect().width}px`;
}

function ocultar(estado) {
  if (estado) estado.tira.style.display = "none";
}

// En celular la barra superior del menú también es fija
function alturaSuperior() {
  const superior = document.querySelector(".sidebar-topbar");
  return superior && getComputedStyle(superior).display !== "none" ? superior.getBoundingClientRect().bottom : 0;
}

function actualizarTitulos(tabla, contenedor, tope) {
  const encabezado = tabla.tHead.getBoundingClientRect();
  const visible = encabezado.top < tope && tabla.getBoundingClientRect().bottom > tope + encabezado.height * 2;
  // Si la tabla ya scrollea por dentro, sus títulos se resuelven ahí mismo
  if (!visible || contenedor.scrollHeight > contenedor.clientHeight + 1) {
    ocultar(tiras.get(tabla));
    return;
  }

  if (!tiras.has(tabla)) tiras.set(tabla, crearTira());
  const estado = tiras.get(tabla);
  if (estado.html !== tabla.tHead.innerHTML) copiarTitulos(tabla, estado);
  ajustarMedidas(tabla, estado);

  const caja = contenedor.getBoundingClientRect();
  estado.tira.style.display = "block";
  estado.tira.style.top = `${tope}px`;
  estado.tira.style.left = `${caja.left}px`;
  estado.tira.style.width = `${contenedor.clientWidth}px`;
  estado.copia.style.transform = `translateX(${encabezado.left - caja.left}px)`;
}

function crearBarra() {
  barra = document.createElement("div");
  barra.className = "barra-horizontal-fija";
  contenidoBarra = document.createElement("div");
  barra.appendChild(contenidoBarra);
  document.body.appendChild(barra);
  barra.addEventListener("scroll", () => {
    if (tablaDeBarra) contenedorDe(tablaDeBarra).scrollLeft = barra.scrollLeft;
  });
}

function actualizarBarra(tablas) {
  // Con el dedo la tabla se mueve de lado directamente
  if (window.matchMedia("(pointer: coarse)").matches) return;
  const alto = window.innerHeight;
  const tabla = tablas.find((t) => {
    const c = contenedorDe(t);
    const caja = c.getBoundingClientRect();
    return c.scrollWidth > c.clientWidth + 1 && caja.top < alto - 80 && caja.bottom > alto;
  });

  if (!barra) crearBarra();
  tablaDeBarra = tabla || null;
  if (!tabla) {
    barra.style.display = "none";
    return;
  }

  const contenedor = contenedorDe(tabla);
  const caja = contenedor.getBoundingClientRect();
  barra.style.display = "block";
  barra.style.left = `${caja.left}px`;
  barra.style.width = `${contenedor.clientWidth}px`;
  contenidoBarra.style.width = `${contenedor.scrollWidth}px`;
  if (barra.scrollLeft !== contenedor.scrollLeft) barra.scrollLeft = contenedor.scrollLeft;
}

// Las fechas AAAA-MM-DD se parten en cada guion y hacen el renglón hasta tres veces más alto
function marcarFechas(tabla) {
  tabla.querySelectorAll("tbody td:not([data-revisada])").forEach((td) => {
    td.dataset.revisada = "";
    if (FECHA.test(td.textContent.trim())) td.classList.add("td-fecha");
  });
}

function actualizar() {
  const tablas = Array.from(document.querySelectorAll("#root table")).filter(
    (t) => t.tHead && t.offsetParent !== null
  );
  const tope = alturaSuperior();

  tablas.forEach((tabla) => {
    marcarFechas(tabla);
    actualizarTitulos(tabla, contenedorDe(tabla), tope);
  });
  tiras.forEach((estado, tabla) => {
    if (tabla.isConnected) return;
    estado.tira.remove();
    tiras.delete(tabla);
  });
  actualizarBarra(tablas);
}

let pendiente = false;
function programar() {
  if (pendiente) return;
  pendiente = true;
  requestAnimationFrame(() => {
    pendiente = false;
    actualizar();
  });
}

document.addEventListener("scroll", programar, { capture: true, passive: true });
document.addEventListener("transitionend", programar);
window.addEventListener("resize", programar);
new MutationObserver(programar).observe(document.getElementById("root"), {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["class"],
});
